<template>
  <div class="app">
    <div class="card2-content2">
      <div v-for="(item,index) in list" :key="index" @click="goDetail(item)">
        <div class="card2-content2-l">
          <img v-if="item.imgUrl" :src="item.imgUrl[0]" alt="">
        </div>
        <div class="card2-content2-r">
          <p><img v-if="index<5" src="@images/new.png"/> {{item.bt}}</p>
          <p >{{item.createTime}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default() {
        return []
      },
    },
    // 自定义返回逻辑
    clickItem: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      listData: [],
    }
  },
  watch: {
    list: {
      immediate: true,
      handler() {
        this.listData = this.list
      },
    },
  },
  created() {},
  methods: {
    goDetail: function (e) {
      this.$store.state.tzggView = e
      if (typeof this.clickItem === 'function') {
        this.clickItem(e.id)
      } else {
        this.$router.push({
          path: '/xxgk/tzgg-view',
          query: { id: e.id },
        })
      }
    },
  },
}
</script>

<style lang="less">
.app{
  padding: 0px 10px;
}
.news-card {
  height: auto;
  background: #ffffff;
  border-bottom: 1px solid #eee;
  display: flex;
  padding: 12px 10px;
  position: relative;

  .title {
    color: #333333;
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 10px;
  }

  .img {
    width: 64px;
    height: 64px;
    margin-right: 10px;
  }

  .theme {
    font-size: 14px;
    font-weight: 400;
    color: #303133;
  }

  .title{
    font-size: 15px;
    font-weight: 600;
    color: #303133;
  }

  .time {
    font-size: 13px;
    font-weight: 400;
    color: #999999;
    margin-top: 10px;
    margin-left: auto;
  }

  .dz {
    font-size: 14px;
    font-weight: 400;
    color: #999999;
  }
}
.card2{
  margin:0px 8px 10px;
  padding: 12px 8px;
  .title{
    width: 100%;
    position: relative;
    margin: 0px 0px 10px;
    display: flex;
    box-sizing: border-box;
    padding: 0px 0px 0px 10px;
    justify-content: space-between;
    p{
      margin: 0px;
      padding: 0px;
      letter-spacing: 1px;
    }
    p:last-child{
      color: #999;
    }
  }
  .title::before{
    content: "";
    width: 4px;
    height: 100%;
    position: absolute;
    left: 0px;
    top: 0px; 
    background: #39a9ed;
  }
  &-content{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    div{
      width: 45%;
      height: 70px;
      display: flex;
      margin: 0px 0px 10px;
      align-items: center;
      justify-content: center;
      img{
        width: 100%;
        height: 100%;
      }
    }
  }
  &-content2{
    >div{
      display: flex;
      height: 70px;
      margin: 10px 0px 10px;
      padding-bottom: 10px;
      border-bottom:1px solid #f3f3f3;
      justify-content: space-between;
    }
    &-l{
      width: 90px;
      height: 70px;
      display: flex;
      align-items: center;
       background: #dedede;
      img{
        width: 100%;
        height:100%;
       
      }
    }
    &-r{
      width: 70%;
      height: 100%;
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      position: relative;
      justify-content: space-between;
      div{
        display: flex;
        align-items: center;
      }
      p{
        margin: 0px;
        padding: 0px;
        font-size: 14px;
        overflow: hidden;
        line-height: 20px;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        display: -webkit-box;
      }
      img{
        height: 14px;
      }
    }
  }
}
	.jiaobiao{width: 80px; height: 80px; background: #99adc2; color: #fff; display: flex; align-items: flex-end; transform: rotate(45deg); -webkit-transform: rotate(45deg); position: absolute; font-size: 12px; top: -48px; right: -48px; justify-content: center;}
	.jiaobiao font{position: relative; top: 2px; letter-spacing: 1px;}
</style>
